<template>
  <base-button
    class="function-button"
    :class="classObject"
    :value="value"
    :text="text"
    :icon="icon"
    :button-color="buttonColor"
    :content-fit="contentFit"
    :toggle="toggle"
    :pressed="pressed"
    :disabled="disabled"
    :outlined="outlined"
    :shadow="shadow"
    :rounded="rounded"
    :processing="processing"
    :new-button="newButton"
    @click="handleClick"
  >
    <template v-if="unit" #taggedText>
      <strong>{{ textWithoutUnit }}</strong
      >{{ unit }}
    </template>
  </base-button>
</template>

<script setup>
import BaseButton from '@/components/BaseButton'

const props = defineProps({
  /**
   * 値
   */
    value: {
    type: String,
    default: '',
  },
  /**
   * テキスト
   */
  text: {
    type: String,
    required: true,
  },
  /**
   * 単位（例：月, 日, 分）
   */
  unit: {
    type: String,
    default: '',
  },
  /**
   * アイコン名
   * @values location, zoom
   */
  icon: {
    type: String,
    default: '',
  },
  /**
   * 色
   * @values primary, secondary, tertiary, caution, warning
   */
  buttonColor: {
    type: String,
    default: 'primary',
  },
  /**
   * なりゆき幅
   */
  contentFit: {
    type: Boolean,
    default: false,
  },
  /**
   * トグルボタンとして使うかどうか
   */
  toggle: {
    type: Boolean,
    default: false,
  },
  /**
   * トグルボタンの押下状態
   */
  pressed: {
    type: Boolean,
    default: false,
  },
  /**
   * 無効状態
   */
  disabled: {
    type: Boolean,
    default: false,
  },
  /**
   * 枠線を残してボタンの背景色を透過状態
   */
  outlined: {
    type: Boolean,
    default: false,
  },
  /**
   * 影の状態(デフォルトはtrue)
   */
  shadow: {
    type: Boolean,
    default: true,
  },
  /**
   * 角丸状態(デフォルトはtrue)
   */
  rounded: {
    type: Boolean,
    default: true,
  },
  /**
   * 処理中
   */
  processing: {
    type: Boolean,
    default: false,
  },
  newButton: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['click'])

const classObject = computed(() => {
  return {
    'with-unit': props.unit,
  }
})

const textWithoutUnit = computed(() => {
  return props.text.replace(props.unit, '')
})

const handleClick = (data) => {
  emit('click', data)
}
</script>

<style lang="scss" scoped>
.function-button {
  &.with-unit {
    font-size: 1rem;
    align-items: baseline;

    > strong {
      font-size: 1.4rem;
      font-weight: bold;
    }
  }
}
</style>
